"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Options = exports.Title = exports.Header = exports.Body = exports.Section = void 0;
const React = require("react");
const react_1 = require("react");
const CollapsibleContext_1 = require("../../../../contexts/CollapsibleContext");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "baseSection");
/**
 * Component used as foundation for Sections of content. Provides some behaviour and minimal style.
 */
const Section = ({ children, className, open = true, isCollapsible = false, fullWidth = false, state = "", fancy = false, id = "", size = "", candycane = false, narrow = false, dataTest = "section" }) => {
    const [isCollapsed, setIsCollapsed] = (0, react_1.useState)(!open);
    // tie together
    (0, react_1.useEffect)(() => {
        setIsCollapsed(!open);
    }, [open]);
    const onToggleCollapse = (0, react_1.useCallback)(() => {
        setIsCollapsed(!isCollapsed);
    }, [isCollapsed]);
    const provider = isCollapsible
        ? {
            onToggleCollapse,
            isCollapsed
        }
        : {
            onToggleCollapse: undefined,
            isCollapsed
        };
    const classes = css("", `-size-${size}`, `-state-${state}`, {
        "-collapsible": isCollapsible,
        "-collapsed": isCollapsed,
        "-fancy": fancy,
        "-fullWidth": fullWidth,
        "-candycane": candycane,
        "-narrow": narrow,
        className
    });
    return (React.createElement(CollapsibleContext_1.CollapsibleContext.Provider, { value: provider },
        React.createElement("div", { className: classes, id: id, "data-test": dataTest }, children)));
};
exports.Section = Section;
const Body_1 = require("./components/Body");
Object.defineProperty(exports, "Body", { enumerable: true, get: function () { return Body_1.Body; } });
const Header_1 = require("./components/Header");
Object.defineProperty(exports, "Header", { enumerable: true, get: function () { return Header_1.Header; } });
const Title_1 = require("./components/Title");
Object.defineProperty(exports, "Title", { enumerable: true, get: function () { return Title_1.Title; } });
const Options_1 = require("./components/Options");
Object.defineProperty(exports, "Options", { enumerable: true, get: function () { return Options_1.Options; } });
//# sourceMappingURL=index.js.map